module.exports = __webpack_public_path__ + "img/model_32.0aefdcc8.jpg";